module.exports = __webpack_public_path__ + "static/media/dcapa.023717c7.png";